function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useCallback, useEffect, useState } from 'react';
import { Input } from 'antd';
import { BetterSelect } from '../better-select/better-select';
import { useDataViewContext } from './context';
import dotProp from 'dot-prop';
import classnames from 'classnames';
import deepEqual from 'react-fast-compare';
var LOCAL_STORAGE_VALUE_KEY = 'v';
var LOCAL_STORAGE_MIGRATED_KEY = 'mx';
var getStickyContainer = function getStickyContainer() {
  var _localStorage$getItem;
  return JSON.parse((_localStorage$getItem = localStorage.getItem('sw.dv')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '{}');
};
var setStickyContainer = function setStickyContainer(value) {
  return localStorage.setItem('sw.dv', JSON.stringify(value));
};

/**
 * Retrieves localStorage path + key combination value.
 *
 * If a migrationHydrator is passed an attempt to migrate
 * legacy data is performed. Hydrated date is then saved
 * over any existing data and the key will be marked as
 * hydrated to prevent the need for future hydration.
 *
 * @param prefix - The dot notation string path to the key container. eg: `d.{id}.{view}.f.{name}`
 * @param key - The filter storage key. eg: 'v' for value or 'mx' for migrated
 * @param migrationHydrator - Hydration method for pulling from legacy storage location
 */
var getStickyValue = function getStickyValue(prefix, key, migrationHydrator) {
  var container = getStickyContainer();
  var path = "".concat(prefix, ".").concat(key);
  var migrated = dotProp.get(container, "".concat(prefix, ".").concat(LOCAL_STORAGE_MIGRATED_KEY), false);
  var value;
  if (key !== LOCAL_STORAGE_MIGRATED_KEY && migrationHydrator && !migrated) {
    value = migrationHydrator();
    if (value) {
      setStickyValue(prefix, key, value);
      setStickyValue(prefix, LOCAL_STORAGE_MIGRATED_KEY, true);
    }
  } else {
    value = dotProp.get(container, path);
  }
  return value;
};

/**
 * Updates localStorage with the desired path + key + value combination.
 * If an undefined value is passed the property is deleted from storage.
 *
 * @param prefix - The dot notation string path to the key container. eg: `d.{id}.{view}.f.{name}`
 * @param key - The filter storage key. eg: 'v' for value or 'mx' for migrated
 * @param value - The filter value
 */
var setStickyValue = function setStickyValue(prefix, key, value) {
  var container = getStickyContainer();
  if (Array.isArray(value)) {
    value.sort(Intl.Collator().compare);
  }
  var isUndefined = value === undefined;
  var isEmptyArray = !isUndefined && Array.isArray(value) && !value.length;
  if (isUndefined || isEmptyArray) {
    dotProp["delete"](container, "".concat(prefix, ".").concat(key));
  } else {
    dotProp.set(container, "".concat(prefix, ".").concat(key), value);
  }
  setStickyContainer(container);
};
var getSorted = function getSorted(values) {
  values = _toConsumableArray(values);
  values.sort(Intl.Collator().compare);
  return values;
};
export var DataViewFilter = function DataViewFilter(props) {
  var _props$componentProps5, _props$componentProps6;
  var _useDataViewContext = useDataViewContext(),
    _useDataViewContext2 = _slicedToArray(_useDataViewContext, 2),
    state = _useDataViewContext2[0],
    dispatch = _useDataViewContext2[1];
  var type = props.type,
    name = props.name,
    sticky = props.sticky,
    migrationHydrator = props.migrationHydrator;

  // ----- Parse default filter value -----
  var defaultValue = state.filterValues[name];
  if (type !== 'custom') {
    var _props$componentProps, _props$componentProps2;
    // Standard components should give precedence to an explicitly passed value
    defaultValue = (_props$componentProps = (_props$componentProps2 = props.componentProps) === null || _props$componentProps2 === void 0 ? void 0 : _props$componentProps2.value) !== null && _props$componentProps !== void 0 ? _props$componentProps : defaultValue;
  }
  if (Array.isArray(defaultValue)) {
    defaultValue = getSorted(defaultValue);
  }
  // -----

  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    searchLiveTypeTimeout = _useState2[0],
    setSearchLiveTypeTimeout = _useState2[1];
  var _useState3 = useState(defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    localValue = _useState4[0],
    _setLocalValue = _useState4[1];
  var currValue = state.filterValues[name];

  // ----- Storage path -----
  var usingCustomStoragePath = false;
  var localStorageDataViewPath = "".concat(state.levelResource.level[0], ".").concat(state.levelResource.id, ".").concat(state.id);
  if (_typeof(sticky) === 'object') {
    if ('agnostic' in sticky && sticky.agnostic) {
      localStorageDataViewPath = "".concat(state.levelResource.level[0], ".").concat(state.levelResource.id, ".shared");
    } else if ('storageKey' in sticky && sticky.storageKey.trim()) {
      usingCustomStoragePath = true;
      localStorageDataViewPath = "custom.".concat(sticky.storageKey.trim());
    }
  }
  var localStoragePath = "".concat(localStorageDataViewPath, ".f.").concat(name).toLowerCase();
  if (usingCustomStoragePath) {
    localStoragePath = "".concat(localStorageDataViewPath, ".f").toLowerCase();
  }
  // -----

  /**
   * Wraps `_setLocalValue()` ensuring proper formatting and
   * value persistence for sticky filters.
   *
   * The formatted value is returned for use downstream.
   */
  var setLocalValue = useCallback(function (value) {
    if (Array.isArray(value)) {
      value = getSorted(value);
    }
    if (sticky) {
      setStickyValue(localStoragePath, LOCAL_STORAGE_VALUE_KEY, value);
    }
    _setLocalValue(value);
    return value;
  }, [localStoragePath, sticky]);

  /**
   * Builds the `'SET_FILTER_VALUE'` `DataViewAction`
   * package and invokes `dispatch()`
   */
  var onFilterChange = useCallback(function (nextValue) {
    if (!deepEqual(nextValue, currValue)) {
      dispatch({
        type: 'SET_FILTER_VALUE',
        data: {
          key: name,
          value: nextValue
        }
      });
    }
  }, [name, currValue]);
  var onSelectClose = useCallback(function (nextValue) {
    onFilterChange(setLocalValue(nextValue));
  }, [name, currValue, localValue]);
  var onSelectChange = useCallback(function (nextValue) {
    setLocalValue(nextValue);
  }, [name, currValue, localValue]);
  var onSearchClick = useCallback(function (term, _ev) {
    clearTimeout(searchLiveTypeTimeout);
    onFilterChange(setLocalValue(term || undefined));
  }, [name, currValue, localValue, searchLiveTypeTimeout]);
  var onSearchChange = useCallback(function (ev) {
    var term = ev.target.value;

    // Immediately update local value for search input
    term = setLocalValue(term || undefined);
    clearTimeout(searchLiveTypeTimeout);
    setSearchLiveTypeTimeout(setTimeout(function () {
      onFilterChange(term);
    }, 320));
  }, [name, currValue, localValue, searchLiveTypeTimeout]);

  // ----- Initial sticky value retrieval and population -----
  useEffect(function () {
    if (type !== 'search' && sticky) {
      var stickyValue = getStickyValue(localStoragePath, LOCAL_STORAGE_VALUE_KEY, migrationHydrator);
      if (stickyValue) {
        onFilterChange(setLocalValue(stickyValue));
      } else if (!currValue) {
        if (type === 'select') {
          var _props$componentProps3;
          if (defaultValue) {
            // When default value is provided and updated
            // after the initial render we should ensure
            // that it is honored as long as no current
            // selection or sticky value is available
            onFilterChange(setLocalValue(defaultValue));
          } else if ((_props$componentProps3 = props.componentProps) !== null && _props$componentProps3 !== void 0 && _props$componentProps3.options.length) {
            // When no selection has been made yet,
            // no sticky value is available, and no default
            // value was provided we should fall back to ALL
            // available option values as the default value
            var nextValue = [];
            props.componentProps.options.forEach(function (opt) {
              if ('value' in opt) {
                nextValue.push(opt.value);
              } else {
                nextValue.push.apply(nextValue, _toConsumableArray(opt.options.map(function (child) {
                  return child.value;
                })));
              }
            });
            onFilterChange(setLocalValue(nextValue));
          }
        }
      }
    }
  }, [localStoragePath, sticky, !!migrationHydrator]);
  // -----

  var classNames = ['data-view-filter', type, "filter-".concat(name)];
  if (type !== 'custom') {
    var _props$componentProps4;
    classNames.push((_props$componentProps4 = props.componentProps) === null || _props$componentProps4 === void 0 ? void 0 : _props$componentProps4.className);
  }
  var sharedProps = {
    className: classnames(classNames),
    value: localValue,
    disabled: props.disabled
  };
  switch (props.type) {
    case 'search':
      return /*#__PURE__*/React.createElement(Input.Search, _extends({}, props.componentProps, sharedProps, {
        defaultValue: defaultValue,
        enterButton: true,
        onSearch: onSearchClick,
        onChange: onSearchChange
      }));
    case 'select':
      return /*#__PURE__*/React.createElement(BetterSelect, _extends({}, props.componentProps, sharedProps, {
        defaultValue: defaultValue,
        options: (_props$componentProps5 = (_props$componentProps6 = props.componentProps) === null || _props$componentProps6 === void 0 ? void 0 : _props$componentProps6.options) !== null && _props$componentProps5 !== void 0 ? _props$componentProps5 : [],
        mode: "multiple",
        onChange: onSelectChange,
        onClose: onSelectClose
      }));
    case 'custom':
      return props.render(onFilterChange);
    default:
      return null;
  }
};